import { render } from "./nasaha.vue?vue&type=template&id=63347eec"
import script from "./nasaha.vue?vue&type=script&lang=js"
export * from "./nasaha.vue?vue&type=script&lang=js"
script.render = render

export default script